import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Text } from '../../Components/Base';
import AppContainer from '../AppContainer';
import { QueryComponent } from '../../GraphQL';
import { activeExamRound } from '../../GraphQL/query/mockSchool/LinkSchool.query';

export default class EmptyLinkSchool extends Component {
  render() {
    const { menus } = this.props;
    return (
      <QueryComponent query={activeExamRound}>
        {data => {
          if (data && data.mockExamSchoolActiveRound.roundCode) {
            return <Redirect to={`/school/${data.mockExamSchoolActiveRound.roundCode}`} />;
          }
          return (
            <AppContainer menus={menus}>
              <Text>no roundcode and location code</Text>
            </AppContainer>
          );
        }}
      </QueryComponent>
    );
  }
}
